/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import imgMedicament from "assets/images/rubrique/santeAnimal/medicament.webp";
import imgMaladie from "assets/images/rubrique/santeAnimal/maladiePrioritaire.webp";
import imgMaladieNonZoonotique from "assets/images/rubrique/santeAnimal/maladieNonZoonotique.webp";
import imgMaladieZoonotique from "assets/images/rubrique/santeAnimal/maladieZoonotique.webp";
// import imgMaladieNonObligatoire from "assets/images/rubrique/santeAnimal/maladiePrioritaire.webp";
import imgVaccin from "assets/images/rubrique/santeAnimal/vaccin.webp";
import imgDiagnostic from "assets/images/rubrique/santeAnimal/diagnostic.webp";
import imgTraitement from "assets/images/rubrique/santeAnimal/traitement.webp";
import imgTechnique from "assets/images/rubrique/santeAnimal/technique.webp";
import imgExamen from "assets/images/rubrique/santeAnimal/examen.webp";
import imgAuteur from "assets/images/rubrique/santeAnimal/role.webp";
// import imgAnnexe from "assets/images/backlog.png";
import { Grid, IconButton } from "@mui/material";
import CustomCard from "layouts/gestion_sante_animale/component/CustomCard";
import globalStyles from "style";
import { useLocation, useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import {
  PATH_DIAGNOSTIC,
  PATH_MALADIE,
  PATH_MALADIE_NON_ZOONOTIQUE,
  PATH_MALADIE_ZOONOTIQUE,
  PATH_MEDICAMENT,
  PATH_MPSA,
  PATH_TRAITEMENT,
  PATH_VACCIN,
  TITLE_MPSA,
  PATH_TECHNIQUE,
  PATH_MALADIE_NON_OBLIGATOIRE,
  PATH_EXAMEN,
  PATH_PRELEVEMENT,
  PATH_TECHNIQUE_VETERINAIRE,
  PATH_AUTEUR,
  // PATH_ANNEXE,
  // TITLE_ANNEXE,
} from "../../constant/moduleInfo";
import { LAST_PATH } from "constant";
import MDTypography from "components/MDTypography";
// import colors from "assets/theme/base/colors";
import COLORS from "constant/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";

function Index_sante_animale() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const { t } = useTranslation("translation");
  const { i18n } = useTranslation();

  const [gridData, setGridData] = useState([]);
  const [title, setTitle] = useState("");
  /* Element à afficher sur le cardview */
  const mpsaCardData = [
    {
      title: t("technique"),
      img: imgTechnique,
      route: PATH_TECHNIQUE,
    },
    {
      title: t("examen"),
      img: imgExamen,
      route: PATH_EXAMEN,
    },
    {
      title: t("maladies"),
      img: imgMaladie,
      route: PATH_MALADIE,
    },

    {
      title: t("diagnostics"),
      img: imgDiagnostic,
      route: PATH_DIAGNOSTIC,
    },
    {
      title: t("prelevements"),
      img: imgExamen,
      route: PATH_PRELEVEMENT,
    },

    {
      title: t("traitements"),
      img: imgTraitement,
      route: PATH_TRAITEMENT,
    },
    {
      title: t("technique_veterinaire"),
      img: imgExamen,
      route: PATH_TECHNIQUE_VETERINAIRE,
    },
    {
      title: t("auteurs"),
      img: imgAuteur,
      route: PATH_AUTEUR,
    },
  ];
  const maladieCardData = [
    {
      title: t("maladie_non_zoonotique"),
      img: imgMaladieNonZoonotique,
      route: PATH_MALADIE_NON_ZOONOTIQUE,
    },
    {
      title: t("maladie_zoonotique"),
      img: imgMaladieZoonotique,
      route: PATH_MALADIE_ZOONOTIQUE,
    },
    {
      title: t("maladie_non_obligatoire"),
      img: imgMaladie,
      route: PATH_MALADIE_NON_OBLIGATOIRE,
    },
  ];
  const traitementCardData = [
    {
      title: t("medicaments"),
      img: imgMedicament,
      route: PATH_MEDICAMENT,
    },
    { title: t("vaccins"), img: imgVaccin, route: PATH_VACCIN },
    // { id: 3, title: TITLE_ANNEXE, img: imgAnnexe, route: PATH_ANNEXE },
  ];
  // Naviguer vers l'élément choisi
  const onChange_Component = (item) => {
    if (item.route !== undefined) {
      // navigate(item.route, { state: { title: item.title, endPointURL: item.endPointURL } });
      localStorage.setItem(String(LAST_PATH), item.route);
      navigate(item.route);
    } else {
      alert("Rubrique Indisponible");
    }
  };
  const setData = () => {
    let prevPath = "";
    if (state !== null) {
      prevPath = state.prevPath;
    }

    // console.log("fff location.pathname", prevPath, prevPath === PATH_MALADIE_NON_ZOONOTIQUE);
    if (
      prevPath === PATH_MALADIE_NON_ZOONOTIQUE ||
      prevPath === PATH_MALADIE_ZOONOTIQUE ||
      prevPath === PATH_MALADIE_NON_OBLIGATOIRE
    ) {
      setGridData(maladieCardData);
      setTitle(t("maladies"));
    } else if (prevPath === PATH_MEDICAMENT || prevPath === PATH_VACCIN) {
      setGridData(traitementCardData);
      setTitle(t("traitements"));
    } else if (location.pathname === PATH_MPSA) {
      setGridData(mpsaCardData);
      setTitle(TITLE_MPSA);
      // console.log("mpsaCardData //", mpsaCardData);
    } else if (location.pathname === PATH_TRAITEMENT) {
      setGridData(traitementCardData);
      setTitle(t("traitements"));
    } else if (location.pathname === PATH_MALADIE) {
      setGridData(maladieCardData);
      setTitle(t("maladies"));
      // console.log("maladieCardData");
    }
  };
  useEffect(() => {
    localStorage.setItem(String(LAST_PATH), location.pathname);
    setData();
    // console.log("change", i18n.resolvedLanguage);
    // console.log("maladieCardData", mpsaCardData);
  }, [location.pathname, i18n.resolvedLanguage]);
  /* useEffect(() => {
    setData();
    console.log("i18n.resolvedLanguage", i18n.resolvedLanguage);
    console.log("gridData", gridData);
  }, []); */
  const goBack = () => {
    console.log("goBack");
    navigate(PATH_MPSA);
    setGridData(mpsaCardData);
    setTitle(TITLE_MPSA);
  };
  const gobalClasses = globalStyles();
  return (
    <DashboardLayout>
      <DashboardNavbar />

      {title !== TITLE_MPSA && (
        <>
          <MDTypography
            display="block"
            variant="H1"
            fontWeight="medium"
            align="center"
            style={{ color: COLORS.primary }}
          >
            {title}
          </MDTypography>

          <MDBox
            display="flex"
            alignItems="center"
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            <IconButton onClick={goBack}>
              <ArrowBackIcon fontSize="small" style={{ color: "gray" }} />
            </IconButton>
          </MDBox>
        </>
      )}
      <div className={gobalClasses.centerContent} style={{ margin: 15, with: "100%" }}>
        <Grid container spacing={3} sx={{ justifyContent: "center", alignItems: "center" }}>
          {gridData.map((i) => (
            <Grid item xs={12} lg={6} key={i.title}>
              <CustomCard cardData={i} handleShowDetails={onChange_Component} />
            </Grid>
          ))}
        </Grid>
      </div>
    </DashboardLayout>
  );
}

export default Index_sante_animale;
